import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  makeStyles,
  Paper,
  PaperProps,
  Theme,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Draggable from "react-draggable";
import { IEnumerable } from "../../core/models/ModelHelpers";
import uuidv4 from "../../helpers/uuid";

type styleProps = {
  draggable?: boolean;
};

const useStyles = makeStyles<Theme, styleProps>((theme: Theme) => ({
  root: ({ draggable = true }) => ({
    position: "relative",
    cursor: draggable ? "move" : "unset",
  }),

  icon: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.common.white,
  },

  cancel: {
  },

  confirm: {
    "color": theme.palette.common.white,
    "&:hover": {
      color: "#fff",
    },
  },
}));

type SimpleDialogProps = {
  id?: IEnumerable;
  draggable?: boolean;
  title?: React.ReactNode;
  children?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleClose?: () => void;
  handleConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  footer?: boolean;
} & DialogProps;

function SimpleDialog({
  draggable = true,
  title,
  children,
  id,
  handleClose,
  handleConfirm,
  footer,
  cancelText,
  confirmText,
  ...others
}: SimpleDialogProps) {
  const classes = useStyles({ draggable });
  const useId = `#draggable-dialog-${id || uuidv4()}`;
  const theme = useTheme();
  const isMobileResolution = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      id={useId}
      PaperComponent={!isMobileResolution && draggable ? PaperComponent : Paper}
      maxWidth="xs"
      fullWidth
      aria-labelledby={useId}
      onClose={handleClose}
      {...others}
    >
      <DialogTitle id={useId} className={classes.root}>
        {title}
        <IconButton onClick={handleClose} className={classes.icon}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>

      {footer && (
        <DialogActions>
          {handleClose && (
            <Button onClick={handleClose} variant="outlined" className={classes.cancel}>
              {cancelText ? cancelText : "Cancelar"}
            </Button>
          )}
          {handleConfirm && (
            <Button
              autoFocus
              onClick={handleConfirm}
              variant="contained"
              color="primary"
              className={classes.confirm}
            >
              {confirmText ? confirmText : "Confirmar"}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}

function PaperComponent({ id, ...props }: PaperProps) {
  return (
    <Draggable handle={id} cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default SimpleDialog;
